import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
import { Section, SectionHeading } from './Shared';
const faqs = [{
  q: '¿Sirve si estoy comenzando como terapeuta de Chi Kung?',
  a: 'Especialmente si estás comenzando. El sistema te da la estructura clínica desde el primer paciente: no necesitas improvisar ni esperar años de experiencia. El Tomo I es tu base operativa, el Tomo II tu biblioteca de sesiones y el Tomo III tu planificación anual.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibes un correo con el acceso a tu descarga. En menos de 5 minutos tienes todo el Mega Pack disponible.'
}, {
  q: '¿Necesito imprimirlo todo?',
  a: 'No. Está optimizado para usarse en tableta o computadora durante la consulta. Si prefieres imprimirlo, también está diseñado para eso.'
}, {
  q: '¿Qué lo diferencia de un curso de Chi Kung?',
  a: 'Un curso enseña técnica. Este pack te entrega el sistema operativo completo para aplicar lo que ya sabes con criterio clínico, planificación profesional y protección energética real.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí: 7 días, sin preguntas y sin formularios. Si no es lo que esperabas, se te devuelve el 100% del dinero.'
}, {
  q: '¿Puedo compartirlo con otros terapeutas?',
  a: 'El pack es de uso personal y profesional exclusivo. No está autorizada su reproducción ni su distribución.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-56" data-mp="16pa12w1ki75i">
      <SectionHeading eyebrow="Preguntas frecuentes" className="mb-12" data-id="element-57" data-mp="rz2p8z62fmds">
        Lo que más nos preguntan
      </SectionHeading>

      <div className="glass-panel rounded-sm divide-y divide-brand-purpleDark/10" data-id="element-58" data-mp="wxcl7bzm6r0g">
        {faqs.map((faq, i) => <div key={faq.q} data-id="element-59" data-mp="izfrcncjoyph" data-mpi={i}>
            <button type="button" aria-expanded={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 md:px-7 py-5 text-left flex justify-between items-center gap-6 focus:outline-none focus-visible:ring-1 focus-visible:ring-brand-gold hover:bg-brand-surfaceLight/40 transition-colors" data-id="element-60" data-mp="iz68djpx3rta">
              <span className="font-display font-semibold text-base md:text-lg text-brand-purpleDark" data-id="element-61" data-mp="2fwtu0xs99kwy">
                {faq.q}
              </span>
              <Plus className={`w-4 h-4 text-brand-goldDark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-62" data-mp="2az1yzuwbdioj" />
            </button>
            <AnimatePresence initial={false} data-id="element-63" data-mp="33lwk8u0ygm32">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-64" data-mp="33klg2t3llcbf">
                  <p className="px-5 md:px-7 pb-6 text-brand-text/85 text-sm md:text-base leading-relaxed max-w-2xl" data-id="element-65" data-mp="1j6t58yrvz4fn">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};